import {
  always, anyPass, assoc, either, equals, not, pipe, propEq, when,
} from 'ramda';
import i18n from '@/i18n/index';
import { isNotNullAndNotEmpty } from '@/utilities';
import logInDevMode from '@/services/backend/logInDevMode';

const isValidHttpMethod = anyPass([equals('POST'), equals('GET'), equals('DELETE')]);
const isPostHttpMethod = propEq('POST', 'method');
const isDeleteHttpMethod = propEq('DELETE', 'method');

const createRequestWith = (options) => {
  const { method = 'GET', request, sessionId } = options;

  if (not(isValidHttpMethod(method))) return {};

  const currentLocale = i18n.global.locale.value;
  const headers = pipe(
    assoc('Content-type', 'application/json; charset=UTF-8'),
    assoc('accept-language', currentLocale),
    when(always(isNotNullAndNotEmpty(sessionId)), assoc('X-SESSION-ID', sessionId)),
  )({});

  return pipe(
    when(either(isPostHttpMethod, isDeleteHttpMethod), assoc('body', JSON.stringify(request))),
    logInDevMode,
  )({
    method,
    headers,
  });
};

export default createRequestWith;
